// extracted by mini-css-extract-plugin
module.exports = {"scrollIconDot":"style_scrollIconDot___cK4Q","scroll-down":"style_scroll-down__7QY0b"};